"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cached = Cached;
exports.Deprecated = Deprecated;

var _moize = _interopRequireDefault(require("moize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module skat-web-essentials/decorators
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Thursday, 15th August 2019 9:05:13 am
 * @copyright 2015 - 2019 SKAT LLC, Delive LLC
 */

/**
 * Method decorator. Value memoization
 * @decorator Cached
*/
function Cached({
  isPromise,
  isDeepEqual,
  maxSize,
  maxAge
}) {
  return function (Descriptor) {
    let {
      kind,
      key,
      descriptor,
      placement
    } = Descriptor;
    return {
      kind,
      key,
      placement,
      descriptor: {
        configurable: true,
        enumerable: false,
        writable: false,
        value: function (...args) {
          let newFunction = (0, _moize.default)(descriptor.value.bind(this), {
            isPromise,
            isDeepEqual,
            maxSize,
            maxAge
          });
          Object.defineProperty(this, key, {
            value: newFunction
          });
          return newFunction(...args);
        }
      }
    };
  };
}
/**
 * Method decorator. Value memoization
 * @decorator Cached
*/


function Deprecated(reason) {
  return function (Descriptor) {
    let {
      kind,
      key,
      descriptor,
      placement
    } = Descriptor;
    return {
      kind,
      key,
      placement,
      descriptor: {
        configurable: true,
        enumerable: false,
        writable: false,
        value: function (...args) {
          console.warn('💩 The function is obsolete');
          console.warn(reason);
          const value = descriptor.value.bind(this);
          Object.defineProperty(this, key, {
            value
          });
          return value(...args);
        }
      }
    };
  };
}